import Model, { attr, belongsTo } from '@ember-data/model';

import type UserDocumentTemplate from './user-document-template';

export default class UserDocumentTemplateConfiguration extends Model {
  @belongsTo('user-document-template', { async: false, inverse: null })
  declare userDocumentTemplate: UserDocumentTemplate;

  @attr('boolean') declare optional: boolean;

  get identifier(): UserDocumentTemplate['identifier'] {
    return this.userDocumentTemplate.identifier;
  }
}
